export const colorSchema = ['gray', 'yellow', 'green']

export const colorConverter: Record<string, string> = {
    gray: '#475468',
    yellow: '#b8ab97',
    green: '#336666',
}
